// extracted by mini-css-extract-plugin
module.exports = {"page-container":"news_page-container__1cfOb","title":"news_title__PZobQ","grid-container":"news_grid-container__1TQXS"};